const getTranslatedField = (translations, field, defaultLang = 'en') => {
    if (!translations || !Array.isArray(translations)) return null;

    const defaultTranslation = translations.find(t => t.language === defaultLang);
    if (defaultTranslation && defaultTranslation[field]) {
        return defaultTranslation[field];
    }

    const anyTranslation = translations.find(t => t[field]);
    return anyTranslation ? anyTranslation[field] : null;
};

export default getTranslatedField;